// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tkex","name":"styles_name__3nQ0K","phone":"styles_phone__1qy90"};